import { http } from "../../../common/helpers/http";
import { baseUrl } from "../../../common/config";

export const getCategories = () => http.get(`${baseUrl}/api/categories/list`);
